import type { Avatar } from "@coup/shared";
import { useState } from "react";
import { saveProfile } from "../state/session";
import { useStore } from "../state/store";
import { AvatarBuilder, randomPreset, type Preset } from "./AvatarBuilder";
import ui from "./ui.module.css";

interface Props {
  name: string;
  avatar: Avatar;
  onClose: () => void;
}

/** Edit your name and avatar between matches. */
export function ProfileModal(props: Props) {
  const send = useStore((s) => s.send);
  const [name, setName] = useState(props.name);
  const [avatar, setAvatar] = useState(props.avatar);
  const [preset, setPreset] = useState<Preset>(
    props.avatar.kind === "preset"
      ? props.avatar
      : { ...randomPreset(), frame: props.avatar.frame },
  );
  const trimmed = name.trim();

  const save = () => {
    send({ t: "profile", name: trimmed, avatar });
    saveProfile(trimmed, avatar);
    props.onClose();
  };

  return (
    <div className={ui.scrim} onClick={props.onClose}>
      <div
        className={ui.modal}
        style={{ width: 580, alignItems: "stretch" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={ui.heading}>Who are you?</div>
        <AvatarBuilder
          name={name}
          avatar={avatar}
          preset={preset}
          onName={setName}
          onAvatar={(a, p) => {
            setAvatar(a);
            setPreset(p);
          }}
        />
        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          <button type="button" className={ui.ghost} onClick={props.onClose}>
            Cancel
          </button>
          <button
            type="button"
            className={ui.primary}
            style={{ height: 44, padding: "0 24px" }}
            disabled={!trimmed}
            onClick={save}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
